import { ValidationRule } from './types'
import { validators } from './validator'

export const validateField = (
  selector: string,
  rules: ValidationRule[]
): boolean => {
  const element = document.querySelector(selector) as HTMLInputElement
  if (!element) return false

  return rules.every(rule => {
    const value = element.value ?? element.textContent
    switch (rule.type) {
      case 'email':
        return validators.email(value)
      case 'phone':
        return validators.phone(value)
      case 'length':
        return validators.length(value, rule.params?.min, rule.params?.max)
      case 'required':
        return validators.required(value)
      case 'regex':
        return rule.params?.pattern
          ? validators.regex(value, rule.params.pattern)
          : true
      case 'custom':
        return rule.params?.customValidator
          ? rule.params.customValidator(value)
          : true
      default:
        return true
    }
  })
}
